import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const OrdersPage = lazy(() => import('@cobliteam/crm/src/pages/OrdersPage'));
const OrderDetailsPage = lazy(() => import('@cobliteam/crm/src/pages/OrderDetailsPage/OrderDetailsPage'));

const routes = [
  {
    path: Location.ORDERS,
    component: OrdersPage,
    exact: true,
  },
  {
    path: Location.ORDER_DETAILS,
    component: OrderDetailsPage,
    exact: true,
  },
];

export default routes;
